import { IsString } from "class-validator";

export class TransferApplicationsDto {
  /**
   * The JWT of the guest user, needed to verify the phone number
   * that the applications must match before being transferred.
   */
  @IsString()
  guestToken: string;
}